// extracted by mini-css-extract-plugin
module.exports = {"generic-spinner":"GenericSpinner_generic-spinner__StL56","rotate":"GenericSpinner_rotate__N6hOW","dash":"GenericSpinner_dash__kSSdt","center":"GenericSpinner_center__JjNmZ"};